var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftStub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17301_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17301_3807)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.9998 13.296V23.0399L33.3918 20.7999C32.1439 19.728 30.1279 19.728 28.8799 20.7999L22.2239 26.5119C20.9759 27.5839 18.9599 27.5839 17.7119 26.5119L17.1679 26.0639C16.0319 25.0719 14.2239 24.9759 12.9439 25.8399L5.07189 31.1199L3.99976 32.6144C3.99976 32.6144 3.99989 28.4479 3.99989 26.7039V13.296V4H35.9998V13.296Z",
    fill: "#00D180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1998 17.408C17.3029 17.408 19.0078 15.7031 19.0078 13.6C19.0078 11.4969 17.3029 9.79199 15.1998 9.79199C13.0967 9.79199 11.3918 11.4969 11.3918 13.6C11.3918 15.7031 13.0967 17.408 15.1998 17.408Z",
    fill: "#00D180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 23.0401V36C36 36 32.528 36 26.704 36H4V31.813L12.944 25.8401C14.224 24.9761 16.032 25.0721 17.168 26.0641L17.712 26.5121C18.96 27.5841 20.976 27.5841 22.224 26.5121L28.88 20.8001C30.128 19.7281 32.144 19.7281 33.392 20.8001L36 23.0401Z",
    fill: "#00D180"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17301_3807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17301_3807"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftStub);
export default __webpack_public_path__ + "static/media/nft-stub.891e93fcc894600c7ab00729c6b2d804.svg";
export { ForwardRef as ReactComponent };